

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL, USER_URL } from '../../constant/api';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ProfileEditProfile() {
  const [editingPersonalInfo, setEditingPersonalInfo] = useState({
    first_name: '',
    last_name: '',
    address: '',
    mobile_number: '',
    country: '',
    state: '',
    city: '',
    post_code: '',
  });

  const [isLoading, setIsLoading] = useState(true);
  const [countries, setCountries] = useState([]); // Store country list
const [states, setStates] = useState([]); // Store state list


  const fetchPersonalInfo = async () => {
    // const token = localStorage.getItem("token");
    // const headers = { Authorization: `Token ${token}` };

    try {
      const response = await USER_URL.get(`/accounts/profile-update/`, );
      const data = response.data?.Data?.[0] || {};

      setEditingPersonalInfo({
        first_name: data.first_name || '',
        last_name: data.last_name || '',
        address: data.address || '',
        mobile_number: data.mobile_number || '',
        country: data.country || '',
        state: data.state || '',
        city: data.city || '',
        post_code: data.post_code || '',
      });
    } catch (error) {
      toast.error('Error fetching personal info:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/accounts/countries/`);
      
      if (Array.isArray(response.data.Data)) {
        setCountries(response.data.Data.map(country => country.name)); // Extract names
      } else {
        console.error("Unexpected countries response:", response.data);
        setCountries([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountries([]);
    }
  };
  
  
  const fetchStates = async (selectedCountry) => {
    try {
      const response = await axios.get(`${BASE_URL}/accounts/states/?country=${selectedCountry}`);
  
      if (Array.isArray(response.data.Data)) {
        setStates(response.data.Data.map(state => state.name)); // Extract state names
      } else {
        console.error("Unexpected states response:", response.data);
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStates([]);
    }
  };
  
  
useEffect(() => {
  fetchPersonalInfo();
  fetchCountries();
}, []);


  const handlePersonalChange = (e) => {
    const { name, value } = e.target;
    setEditingPersonalInfo({ ...editingPersonalInfo, [name]: value });
  
    // Fetch states when country changes
    if (name === "country") {
      fetchStates(value);
      setEditingPersonalInfo((prev) => ({ ...prev, state: "" })); // Reset state
    }
  };
  

  const savePersonalDetails = async (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };

    try {
      await USER_URL.patch(`/accounts/profile-update/`, editingPersonalInfo, { headers });
       toast.success("Profile updated successfully!");
    } catch (error) {
       toast.error("Failed to save profile info");
      console.log("Error saving profile details:", error);
    }
  };

  useEffect(() => {
    fetchPersonalInfo();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-10 mt-5">
    <ToastContainer position="top-center" autoClose={2000} />
    <h1 className="text-2xl font-bold text-green-600">Edit Profile</h1>
  
    <form className="w-full my-6" onSubmit={savePersonalDetails}>
      {/* First Name & Last Name */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="flex flex-col">
          <label className="text-sm font-semibold">First Name</label>
          <input
            type="text"
            name="first_name"
            placeholder="First Name"
            value={editingPersonalInfo.first_name}
            onChange={handlePersonalChange}
            className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-semibold">Last Name</label>
          <input
            type="text"
            name="last_name"
            placeholder="Last Name"
            value={editingPersonalInfo.last_name}
            onChange={handlePersonalChange}
            className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
            required
          />
        </div>
      </div>
  
      {/* Address - Full Width */}
      <div className="mt-6 flex flex-col">
        <label className="text-sm font-semibold">Address</label>
        <textarea
          name="address"
          placeholder="Address"
          value={editingPersonalInfo.address}
          onChange={handlePersonalChange}
          className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
          required
        />
      </div>
  
      {/* Other Fields - Two Columns */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">

      <div className="flex flex-col">
  <label className="text-sm font-semibold">Country</label>
  <select
  name="country"
  value={editingPersonalInfo.country}
  onChange={handlePersonalChange}
  className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
  required
>
  <option value="">Select Country</option>
  {countries.map((country, index) => (
    <option key={index} value={country}>{country}</option>
  ))}
</select>

</div>
        <div className="flex flex-col">
          <label className="text-sm font-semibold">Phone Number</label>
          <input
            type="tel"
            name="mobile_number"
            placeholder="Phone Number"
            value={editingPersonalInfo.mobile_number}
            onChange={handlePersonalChange}
            className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
            required
          />
        </div>
       

<div className="flex flex-col">
  <label className="text-sm font-semibold">State</label>
  <select
  name="state"
  value={editingPersonalInfo.state}
  onChange={handlePersonalChange}
  className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
  required
>
  <option value="">Select State</option>
  {states.map((state, index) => (
    <option key={index} value={state}>{state}</option>
  ))}
</select>

</div>

        <div className="flex flex-col">
          <label className="text-sm font-semibold">City</label>
          <input
            type="text"
            name="city"
            placeholder="City"
            value={editingPersonalInfo.city}
            onChange={handlePersonalChange}
            className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-semibold">Pincode</label>
          <input
            type="text"
            name="post_code"
            placeholder="Pincode"
            value={editingPersonalInfo.post_code}
            onChange={handlePersonalChange}
            className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
            required
          />
        </div>
  
        {/* Save Button */}
        <button
          type="submit"
          className="w-full bg-green-600 text-white p-3 rounded-lg hover:bg-green-700 transition mt-5"
        >
          Save
        </button>
      </div>
    </form>
  
    <Link
  to={"/profile/add_edit_organization"}
  className="w-full mt-8 p-3 text-black rounded text-lg font-semibold flex items-center"
>
  <span className="flex items-center gap-2">
    Edit & Add Your Organization 
    <span className="text-4xl text-green-500 transition-colors duration-300 hover:text-green-700">
      +
    </span>
  </span>
</Link>


  </div>
  

  );
}

export default ProfileEditProfile;


